import React from 'react';

export default () => (
    <svg
        width="24px"
        height="21px"
        viewBox="0 0 24 21"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="discovery---posting-and-commenting"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Exports"
                transform="translate(-276.000000, -320.000000)"
                fill="#2A4473"
            >
                <g
                    id="Combined-Shape"
                    transform="translate(276.000000, 320.000000)"
                >
                    <path d="M12,8.28947368 C10.1925226,8.28947368 8.72727273,9.7740032 8.72727273,11.6052632 C8.72727273,13.4365231 10.1925226,14.9210526 12,14.9210526 C13.8074774,14.9210526 15.2727273,13.4365231 15.2727273,11.6052632 C15.2727273,11.2654328 15.2222686,10.9375428 15.1285279,10.6288642 C14.8719691,11.204589 14.3003499,11.6052632 13.6363636,11.6052632 C12.732625,11.6052632 12,10.8629984 12,9.94736842 C12,9.27464547 12.3954706,8.69550499 12.9637184,8.43557044 C12.6590487,8.34059631 12.335417,8.28947368 12,8.28947368 Z M5.23636364,3.31578947 L6.14018457,1.0265062 C6.36400899,0.45958248 7.03538857,0 7.6313428,0 L16.3686572,0 C16.9683767,0 17.6368133,0.461665333 17.8598154,1.0265062 L18.7636364,3.31578947 L21.8171945,3.31578947 C23.0227247,3.31578947 24,4.30446257 24,5.52866873 L24,18.7871207 C24,20.0092602 23.0219502,21 21.8171945,21 L2.18280545,21 C0.977275288,21 0,20.0113269 0,18.7871207 L0,5.52866873 C0,4.30652926 0.978049764,3.31578947 2.18280545,3.31578947 L5.23636364,3.31578947 Z M2.18280545,5.52631579 L2.18181818,18.7871207 L21.8171945,18.7894737 L21.8181818,5.52866873 L17.8331034,5.52630854 C17.5312081,5.52631255 17.196014,5.29840815 17.0837201,5.01549033 L15.9703924,2.21052632 L8.02271266,2.21028495 L6.91808681,5.00818597 C6.80511125,5.29434117 6.46993522,5.52631579 6.16701565,5.52631579 L2.18280545,5.52631579 Z M6.54545455,11.6052632 C6.54545455,8.55316322 8.98753773,6.07894737 12,6.07894737 C15.0124623,6.07894737 17.4545455,8.55316322 17.4545455,11.6052632 C17.4545455,14.6573631 15.0124623,17.1315789 12,17.1315789 C8.98753773,17.1315789 6.54545455,14.6573631 6.54545455,11.6052632 Z" />
                </g>
            </g>
        </g>
    </svg>
);
